import React from 'react';
import PropTypes from 'prop-types';
import Field from './Field';

import './SelectField.scss';



export default function SelectField({ style, label, value, onChange, options, error }) {
  return (
    <Field
      style={style}
      className="form-select-field"
      label={label}
      value={value}
      error={error}
    >
      {(onFocus, onBlur, focus) => {
        return (
          <select
            type="text"
            value={value || ''}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={() => {
              onBlur(value);
            }}
            ref={(input) => {
              if (input && focus) {
                input.focus();
              }
            }}
          >
            <option value="" />
            {options.map((option) => {
              return (
                <option key={option.value} value={option.value}>{option.label}</option>
              );
            })}
          </select>
        );
      }}
    </Field>
  );
}

SelectField.propTypes = {
  style: PropTypes.shape(),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
  })).isRequired,
  label: PropTypes.string,
  value: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.node,
};

SelectField.defaultProps = {
  style: {},
  label: '',
  value: '',
  error: null,
};
